import React, { useState, useEffect } from 'react'
import Logo from '../../../images/rewampimages/Vector.png'
import { emiDetails } from '../../containers/Dashboard/DashboardActionCreator.component'
import Loader from '../../presentationals/Loader/Loader.component'
import { SaveTrnasactionDetailRazorpay, getRazorpayPaymentDetailsById, ValidateApiTrnasactionDetailRazorpay } from '../../containers/Admin/AdminActionCreator.component'
import Popup from '../../presentationals/Popup/Popup.component'
export default function TransactionPopupNew({ allDetail, admin, close }) {
    const [loader, setLoader] = useState(false)
    const [emiDetailsData, setEmiDetailsData] = useState([])
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [object, setObject] = useState({
        type: "",
        paymentMode: "",
        emiAmount: "",
        paymentId: "",
        emiOrderId: "",
        emiType: "",
        paymentType: "",
        penaltyWaived: 0.0,
        nachWaived: 0.0,
    })

    useEffect(() => {
        emiDetailsFn()
    }, [])

    const handleObj = (e, type) => {
        setObject((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const emiDetailsFn = () => {
        setLoader(true)
        emiDetails(allDetail, callback => {
            setLoader(false)
            setEmiDetailsData(callback)
        })
    }



    const saveTransHandler = () => {
        const obj = {
            "userId": allDetail?.userId,
            "loanId": allDetail?.loanId,
            "emiId": object?.emiType || null,
            "razorpayPaymentId": object?.paymentId,
            "razorpayOrderId": object?.emiOrderId,
            // "razorpaySignature": "",
            "paidAmount": String(object?.emiAmount),
            // "typeOfProduct": "Loan",
            // "paymentModeType": object?.paymentType,
            "paymentType": object?.paymentType,
            "updatedBy": admin?.emailId,
            "penaltyWaived": Number(object?.penaltyWaived) || 0.0,
            "nachWaived": Number(object?.nachWaived) || 0.0,
            "paymentMode": object?.paymentMode || 0.0,
            "addedManual": true
        }
        console.log("obj", obj)
        setLoader(true)
        if (obj.paymentType == "partPayment") {

            SaveTrnasactionDetailRazorpay(obj, callback => {
                setLoader(false)
                if (callback == "success") {
                    setpopup({ show: true, popupStatus: "Transaction Added Successfully" })
                } else {
                    setpopup({ show: true, popupStatus: "error Adding transaction" })
                }
removePopup()
            })

        } else {
            // ValidateApiTrnasactionDetailRazorpay(obj, callback => {

                // if (callback?.status == "success") {

                    SaveTrnasactionDetailRazorpay(obj, callback => {
                        setLoader(false)
                        if (callback == "success") {
                            setpopup({ show: true, popupStatus: "Transaction Added Successfully" })
                        } else {
                            setpopup({ show: true, popupStatus: "error Adding transaction" })
                        }

                    })
                // } else {
                //     setLoader(false)
                //     setpopup({ show: true, popupStatus: callback?.data ?? "error Validating transaction" })
                // }
                removePopup()
            // })
        }
    }

    const getRazorpayPaymentDetailsByIdFn = () => {
        setLoader(true)
        getRazorpayPaymentDetailsById(object.paymentId, allDetail.loanId, callback => {
            setLoader(false)
            console.log(callback)
            if (callback) {
                setObject({
                    ...object,
                    emiOrderId: callback?.order_id,
                    emiAmount: callback?.amount
                })
            }
        })
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }


    return (
        <>
            <div className="background-blur details-new">

                <div className="popup-main small-popup container-fluid max-width-500px dbl-border" style={{ marginTop: '100px', width: '60%' }}>
                    {
                        loader ? <Loader /> : ''
                    }
                    {
                        popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ''
                    }
                    <div style={{ textAlign: 'right', cursor: 'pointer' }}>
                        <i className="fa fa-times" onClick={() => close()}></i>
                    </div>
                    <h4 style={{ color: '#000', marginTop: '-15px' }}><img src={Logo} style={{ width: '27px' }} />&nbsp;&nbsp;Transaction Details</h4>
                    <div className="row">
                    </div>
                    <div className="row form-group" style={{ marginTop: '20px' }}>
                        <div className="col-sm-4 col-xs-12">
                            <label className="font-12px" style={{ marginTop: '10px' }}>TRANSACTION TYPE</label>
                            <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.type} onChange={(e) => handleObj(e, "type")}>
                                <option value={""}>Select Type</option>
                                <option value={"emi"}>EMI</option>
                                <option value={"loan"}>Foreclose Loan</option>
                            </select>
                        </div>
                        {
                            object?.type === "emi" ?
                                <>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>EMI</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.emiType} onChange={(e) => handleObj(e, "emiType")}>
                                            <option value={""}>Select Type</option>
                                            {
                                                emiDetailsData && emiDetailsData?.length > 0 ?
                                                    emiDetailsData?.map((value, index) => {
                                                        if (value?.STATUS == "paid") return
                                                        return (
                                                            <option value={value?.emiId}>{`EMI-${index + 1} - ${value?.AMOUNT}`}</option>
                                                        )
                                                    })
                                                    : ''}
                                        </select>
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT MODE</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.paymentMode} onChange={(e) => handleObj(e, "paymentMode")}>
                                            <option value={""}>Select Mode</option>
                                            <option value={"razorpayApp"}>Razorpay - APP</option>
                                            <option value={"Payment Link"}>Razorpay - Link</option>


                                        </select>
                                    </div>
                                </>
                                : ''}
                        {
                            object?.type === "loan" ?
                                <>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT MODE</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.paymentMode} onChange={(e) => handleObj(e, "paymentMode")}>
                                            <option value={""}>Select Mode</option>
                                            <option value={"razorpayApp"}>Razorpay - APP</option>
                                            <option value={"Payment Link"}>Razorpay - Link</option>

                                        </select>
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT ID</label>
                                        <input className="form-control" type='text' value={object?.paymentId} onChange={(e) => handleObj(e, "paymentId")} />
                                    </div>

                                </>
                                : ''}
                    </div>

                    {
                        object?.type === "emi" ?
                            <>
                                <div className="row form-group" style={{ marginTop: '15px' }}>

                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT ID</label>
                                        <input className="form-control" type='text' value={object?.paymentId} onChange={(e) => handleObj(e, "paymentId")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT ORDER ID</label>
                                        <input className="form-control" type='text' value={object?.emiOrderId} onChange={(e) => handleObj(e, "emiOrderId")} disabled />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAID AMOUNT</label>
                                        <input className="form-control" type='number' value={object?.emiAmount} onChange={(e) => handleObj(e, "emiAmount")} disabled />
                                    </div>
                                </div>
                                <div className="row form-group" style={{ marginTop: '15px' }}>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT TYPE</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.paymentType} onChange={(e) => handleObj(e, "paymentType")}>
                                            <option value={""}>Select Type</option>
                                            <option value={"partPayment"}>PART PAYMENT</option>
                                            <option value={"fullPayment"}>FULL PAYMENT</option>
                                        </select>
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PENALTY WAIVED</label>
                                        <input className="form-control" type='number' value={object?.penaltyWaived} onChange={(e) => handleObj(e, "penaltyWaived")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>NACH WAIVED</label>
                                        <input className="form-control" type='number' value={object?.nachWaived} onChange={(e) => handleObj(e, "nachWaived")} />
                                    </div>
                                </div>
                            </>
                            : ''}
                    {
                        object?.type === "loan" ?
                            <>
                                <div className="row form-group" style={{ marginTop: '15px' }}>



                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT ORDER ID</label>
                                        <input className="form-control" type='text' value={object?.emiOrderId} onChange={(e) => handleObj(e, "emiOrderId")} disabled />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAID AMOUNT</label>
                                        <input className="form-control" type='number' value={object?.emiAmount} onChange={(e) => handleObj(e, "emiAmount")} disabled />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT TYPE</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.paymentType} onChange={(e) => handleObj(e, "paymentType")}>
                                            <option value={""}>Select Type</option>
                                            <option value={"partPayment"}>PART PAYMENT</option>
                                            <option value={"fullPayment"}>FULL PAYMENT</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="row form-group" style={{ marginTop: '15px' }}>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PENALTY WAIVED</label>
                                        <input className="form-control" type='number' value={object?.penaltyWaived} onChange={(e) => handleObj(e, "penaltyWaived")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>NACH WAIVED</label>
                                        <input className="form-control" type='number' value={object?.nachWaived} onChange={(e) => handleObj(e, "nachWaived")} />
                                    </div>
                                </div>

                            </>
                            : ''}

                    {/* <div className="row form-group">
                    <div className="col-sm-6 col-xs-12">
                        <label className="font-12px" style={{marginTop:'10px'}}>TRANSACTION ID</label>
                        <input type="text" className="form-control" placeholder="ENTER TRANSACTION ID" onChange={(e) => editTransHandler(e, 'trnsId')} />
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <label className="font-12px" style={{marginTop:'10px'}}>TRANSACTION DATE</label>
                        <ReactDatePicker
                            value={transDetail.trnsDateState}
                            selected={trnsDateState}
                            onChange={(e) => editTransHandler(e, 'trnsDate')}
                            className="date-picker form-control"
                            dateFormat="DD-MM-YYYY"
                            placeholderText="ENTER TRANSACTION DATE"
                        />
                    </div>
                </div>

                <div className="row form-group">
                    <div className="col-sm-6 col-xs-12">
                        <label className="font-12px" style={{marginTop:'10px'}}>TRANSACTION MODE</label>
                        <select style={{border:'none'}} className="form-control" id="paymentMode" onChange={(e) => editTransHandler(e, 'trnsMode')}>
                            <option value="">{PLACEHOLDER.SELECT_TRANSACTION_MODE}</option>
                            <option value={STRING.CHEQUE}>{STRING.CHEQUE}</option>
                            <option value={STRING.NET_BANKING}>{STRING.NET_BANKING}</option>
                            <option value='UPI'>UPI</option>

                        </select>
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <label className="font-12px" style={{marginTop:'10px'}}>TRANSACTION AMOUNT</label>
                        <input type="number" className="form-control" placeholder="ENTER TRANSACTION AMOUNT" onChange={(e) => editTransHandler(e, 'trnsAmount')} />
                    </div>
                </div> */}
                    {
                        object?.type === "loan" || object?.type === "emi" ?
                            <div className="row text-center form-group">

                                {
                                    object?.emiOrderId !== "" && object?.emiOrderId != null && object?.emiOrderId !== undefined && object?.paymentType !== "" && object?.paymentType != null && object?.paymentType !== undefined & object.paymentMode !== "" && object.paymentMode !== null && object.paymentMode !== undefined
                                        ?
                                        <button className="btn btn-primary" style={{ marginTop: '20px' }} id="transSubmitBtn" onClick={e => saveTransHandler()}>
                                            Save
                                        </button>
                                        :
                                        object?.paymentId !== "" && object?.paymentId != null && object?.paymentId !== undefined ?
                                            <button className="btn btn-primary" style={{ marginTop: '20px' }} id="transSubmitBtn" onClick={e => getRazorpayPaymentDetailsByIdFn()}>
                                                Fetch Payment
                                            </button>
                                            : ''
                                }
                            </div>
                            : ''}
                </div>
            </div>
        </>
    )
}
